import { Image } from '@valbuild/next';
import { PageWidth } from '../../types/types';
import HotspotImage from '../HotspotImage';
import AutoplayVideo from '../AutoplayVideo';

type MediaProps =
  | {
      type: 'image';
      content: Image;
    }
  | {
      type: 'video';
      content: VideoFile;
      autoPlay?: boolean | null;
    };

interface SingleMediaElementProps {
  media: MediaProps;
  size: PageWidth;
  keepAspectRatio?: boolean;
}

interface VideoFile {
  url: string;
  metadata?: {
    mimeType?: string;
  };
}

const renderMediaItem = (media: MediaProps, keepAspectRatio?: boolean) => {
  if (!media) return null;
  const aspectRatio = keepAspectRatio ? null : 'aspect-[23/10]';

  if (media.type === 'video') {
    return (
      <AutoplayVideo
        videoFile={media.content}
        setAspectRatio={aspectRatio}
        autoPlay={media.autoPlay}
      />
    );
  } else {
    return (
      <HotspotImage
        image={media.content}
        setAspectRatio={aspectRatio}
        sizes={'(max-width: 1920px) 100vw, 1872px'}
      />
    );
  }
};

const SingleMediaElement = ({
  media,
  size,
  keepAspectRatio,
}: SingleMediaElementProps) => {
  return (
    <div className={`w-full max-${size}-content laptop:px-128`}>
      {renderMediaItem(media, keepAspectRatio)}
    </div>
  );
};

export default SingleMediaElement;
